import {Component, EventEmitter, Inject, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";


@Component({
   selector: 'modal-dialog-wrapper',
   templateUrl: './dialog-wrapper.component.html',
   styleUrls: ['./dialog-wrapper.component.scss']
})
export class DialogWrapperComponent implements OnInit {
   @Input() optionTemplate: TemplateRef<any> | null = null;
   @Output() onCloseClick = new EventEmitter<any>();

   contextTemplate: {} = {};

   constructor(@Inject(MAT_DIALOG_DATA) public data: {templateRef:TemplateRef<any>, title:string, nome_scheda:string, colore_scheda:string, context:{}}) {
      if (!data.colore_scheda)
         data.colore_scheda = 'scheda-default'
   }

   ngOnInit(): void {
      console.log(this.data.templateRef)
      this.contextTemplate = this.data.context
   }

   closeClick(){
      this.onCloseClick.emit();
   }
}
